import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'
import GlassDesignerTypes from '../types'


// DashedLine Object
// Displays a simple dashed line
// For scaling, thick lines. Use library/three/LineObject
export default class DashedLineObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.startPosition = new THREE.Vector2(0, 0)
    this.endPosition = new THREE.Vector2(0, 0)
    this.colour = options.colour || '#000000'
    this.opacity = parseFloat(options.opacity || 1.0)
    this.dashScale = parseFloat(options.dashScale || 1.0)
    this.dashSize = parseFloat(options.dashSize || 12)
    this.gapSize = parseFloat(options.gapSize || 8)

    this.lineObj = null
    this.objectGeometry = null

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  /**
   * Dispose the object
   */
  dispose() {
    super.dispose()

    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.lineObj = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    // Scale the dashes relative to the camera
    if(this.lineObj) {
      this.lineObj.material.scale = this.editor.camera.zoom * this.dashScale
    }
  }


  // Update the start position of the line
  setStartPosition(pos) {
    this.startPosition.set(pos.x, pos.y)
    this.updateSceneObject()
  }

  // Update the end position of the line
  setEndPosition(pos) {
    this.endPosition.set(pos.x, pos.y)
    this.updateSceneObject()
  }


  /**
   * Build the scene object
   */
  updateSceneObject() {
    if(this.objectGeometry) {
      this.objectGeometry.dispose()
      this.objectGeometry = null
    }
    this.lineObj = null

    this.clearSceneObject()

    // Build line
    var vertices = []
    vertices.push(this.startPosition.x, this.startPosition.y, 0)
    vertices.push(this.endPosition.x, this.endPosition.y, 0)

    this.objectGeometry = new THREE.BufferGeometry();
    this.objectGeometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))

    var lineMaterial = new THREE.LineDashedMaterial({
      color: this.colour,
      transparent: true,
      opacity: this.opacity,
      dashSize: this.dashSize,
      gapSize: this.gapSize,
      scale: this.dashScale
    })
    this.lineObj = new THREE.LineSegments(this.objectGeometry, lineMaterial)
    this.lineObj.computeLineDistances()
    this.sceneObject.add(this.lineObj)
  }
}
